import { BaseModal, ModalResultType, ModalOptions } from "../../modal/index";
import { Template, LazyTemplate } from "../../template/index";
import CoreIcons from "../../icons";

export default class ConfirmModal extends BaseModal
{
    public template = Template.lazy('/core/modals/confirm/index.html');
    public data: ConfirmModalOptions;

    constructor(options?: ConfirmModalOptions)
    {
        super(options);
    }

    public get defaults(): ModalOptions
    {
        return {
            title: this.pgettext('Title', 'Confirmation'),
            message: this.pgettext('Message', 'Are you sure?'),
            iconClass: CoreIcons.Confirmation
        }
    }

    public beforeRender(): PromiseLike<void>
    {
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {
        this.element.querySelector('button.yes').addEventListener('click', e =>
        {
            this.close(ModalResultType.YES);
        });
        this.element.querySelector('button.no').addEventListener('click', e =>
        {
            this.close(ModalResultType.NO);
        });
        return super.afterRender();
    }

    public prompt() {
        return new Promise<boolean>((resolve, reject) =>
        {
            this.app.modals.show(this).then(() =>
            {
                if (this.result.type === ModalResultType.YES)
                {
                    resolve(true);
                }
                else
                {
                    resolve(false);
                }
            });
        });
    }
}

export interface ConfirmModalOptions extends ModalOptions
{
    checkboxText?: string;
    checked?: boolean;
}
